import React, { useState } from "react";
import Box from "../mui/Box";
import Stack from "../mui/Stack";
import { styled } from "@mui/material/styles";
import FormControl from "../mui/FormControl";
import TextField_new from "../mui/TextField_new";
import FormControlLabel from "../mui/FormControlLabel";
import Checkbox from "../mui/Checkbox";
import {
  useListOfProjectsQuery,
  useUserRolesQuery,
} from "../../store/apis/userApi";
import Table from "../common/MagicTable";
import Button from "../mui/Button";
import Typography from "../mui/Typography";
import Text from "../mui/Text";
import Loader from "../common/Loader";
import { CircularProgress } from "@mui/material";
// import { ModuleAccess, RoleFormInterface } from "../../store/types/user";

const StyledLabel = styled(Box)(({ theme }) => ({
  fontSize: "14px !important",
  marginBottom: "3px !important",
  fontWeight: "550 !important",
  color: "#191919 !important",
}));

const StyledCheckboxGroup = styled(Stack)({
  flexDirection: "row",
  flexWrap: "wrap",
});

// Inline styles
const TableHeaderStyle = styled("td")({
  border: "1px solid #ddd",
  backgroundColor: "#DADADA",
  padding: "10px",
  fontWeight: "550",
  fontSize: "13px",
  textAlign: "center",
});

const MainRowStyle = styled("tr")({
  // cursor: "pointer",
  backgroundColor: "#fff",
  border: "1px solid #ddd",
  padding: "8px",
  fontWeight: "500",
  fontSize: "14px",
});

const SubmoduleRowStyle = styled("tr")({
  backgroundColor: "#f9f9f9",
  border: "1px solid #ddd",
  padding: "8px",
});

const RoleForm: React.FC<any> = ({
  formState,
  errors,
  handleCheckboxChange,
  handleMultiCheckbox,
  handleOnChangeValidate,
  projectType = [],
  isLoading = false,
  listOfPrograms = [],
}) => {
  // State to track the visibility of submodules for each module
  const [expandedRows, setExpandedRows] = useState<any>({});

  const toggleRow = (parentIndex: number, index: number) => {
    setExpandedRows((prevState: any) => ({
      ...prevState,
      [`${parentIndex}-${index}`]: !prevState[`${parentIndex}-${index}`], // Toggle the expanded state based on parentIndex and index
    }));
  };

  return (
    <>
      {isLoading ? (
        // <Loader loading={isLoading} size="sm" />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress size={32} sx={{ color: "#FFCB08" }} />
        </Box>
      ) : (
        <Stack direction={"column"}>
          <Stack>
            <StyledLabel>Role Name</StyledLabel>
            <FormControl error={!!errors?.errorMessage} fullWidth>
              <TextField_new
                value={formState.roleName}
                onChange={(e: any) => {
                  // setFormState({ ...formState, roleName: e.target.value })
                  handleOnChangeValidate(e.target.value);
                }}
                id="role-name"
                placeholder="Enter role name"
                helperText={errors.errorMessage}
                error={!!errors.errorMessage}
              />
            </FormControl>

            <StyledLabel>Project Access</StyledLabel>
            <StyledCheckboxGroup sx={{ borderBottom: "1px solid #BEBEBE" }}>
              {projectType.map((role: any) => (
                <FormControlLabel
                  key={role.label}
                  control={
                    <Checkbox
                      size="small"
                      checked={formState?.projectsAccess?.includes(role?.value)}
                      onChange={() =>
                        handleMultiCheckbox(
                          role.value,
                          formState.projectsAccess,
                          "projectsAccess"
                        )
                      }
                      sx={{ "&.Mui-checked": { color: "#FFCA09" } }}
                    />
                  }
                  label={role.label}
                />
              ))}
            </StyledCheckboxGroup>

            {projectType.map((item: any, parentIndex: number) => {
              return (
                <>
                  {formState?.projectsAccess?.includes(item?.value) && (
                    <>
                      {["metalscorecard"].includes(
                        item?.label.toLowerCase().split(" ").join("")
                      ) && (
                        <>
                          <Typography
                            sx={{
                              fontSize: "1.2rem",
                              fontWeight: 600,
                              marginBlock: 2,
                            }}
                          >
                            Metal score card
                          </Typography>
                          <StyledLabel>Program Access</StyledLabel>
                          <StyledCheckboxGroup>
                            {listOfPrograms?.map((program: any) => (
                              <FormControlLabel
                                key={program}
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={formState?.programAccess?.includes(
                                      program?.value
                                    )}
                                    onChange={() =>
                                      handleMultiCheckbox(
                                        program?.value,
                                        formState.programAccess,
                                        "programAccess"
                                      )
                                    }
                                    sx={{
                                      "&.Mui-checked": { color: "#FFCA09" },
                                    }}
                                  />
                                }
                                label={program?.label}
                                value={program?.value}
                              />
                            ))}
                          </StyledCheckboxGroup>
                        </>
                      )}
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 600,
                          marginBlock: 2,
                          marginBlockEnd: "-4px",
                        }}
                      >
                        {item?.label}
                      </Typography>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontFamily: "Arial, sans-serif",
                          marginTop: "15px",
                        }}
                      >
                        <thead>
                          <tr>
                            <TableHeaderStyle
                              sx={{ textAlign: "left !important" }}
                            >
                              Modules
                            </TableHeaderStyle>
                            <TableHeaderStyle>View</TableHeaderStyle>
                            <TableHeaderStyle>Add</TableHeaderStyle>
                            <TableHeaderStyle>Edit</TableHeaderStyle>
                            <TableHeaderStyle>Delete</TableHeaderStyle>
                          </tr>
                        </thead>
                        <tbody>
                          {item?.scopes?.length > 0 ? (
                            item?.scopes?.map((module: any, index: number) => (
                              <React.Fragment key={module.label}>
                                {/* Main Module Row */}
                                <MainRowStyle>
                                  <td
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "10px",
                                    }}
                                  >
                                    {module.label}{" "}
                                    {module?.children?.length > 0 && (
                                      <img
                                        onClick={() =>
                                          toggleRow(parentIndex, index)
                                        }
                                        style={{
                                          cursor: "pointer",
                                          rotate:
                                            expandedRows[
                                              `${parentIndex}-${index}`
                                            ] && "180deg",
                                        }}
                                        src="assets/images/dropdown-btn.svg"
                                        alt="dropdown-btn"
                                      />
                                    )}
                                  </td>
                                  <td>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Checkbox
                                        size="small"
                                        checked={
                                          formState?.moduleAccess[
                                            parentIndex
                                          ]?.[index]?.view
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            parentIndex,
                                            index,
                                            "view",
                                            e.target.checked
                                          )
                                        }
                                        sx={{
                                          "&.Mui-checked": { color: "#FFCA09" },
                                        }}
                                      />
                                    </Box>
                                  </td>
                                  <td>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Checkbox
                                        size="small"
                                        checked={
                                          formState?.moduleAccess[
                                            parentIndex
                                          ]?.[index]?.read
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            parentIndex,
                                            index,
                                            "read",
                                            e.target.checked
                                          )
                                        }
                                        sx={{
                                          "&.Mui-checked": {
                                            color: "#FFCA09",
                                          },
                                        }}
                                      />
                                    </Box>
                                  </td>
                                  <td>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Checkbox
                                        size="small"
                                        checked={
                                          formState?.moduleAccess[
                                            parentIndex
                                          ]?.[index]?.write
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            parentIndex,
                                            index,
                                            "write",
                                            e.target.checked
                                          )
                                        }
                                        sx={{
                                          "&.Mui-checked": {
                                            color: "#FFCA09",
                                          },
                                        }}
                                      />
                                    </Box>
                                  </td>
                                  <td>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Checkbox
                                        size="small"
                                        checked={
                                          formState?.moduleAccess[
                                            parentIndex
                                          ]?.[index]?.delete
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            parentIndex,
                                            index,
                                            "delete",
                                            e.target.checked
                                          )
                                        }
                                        sx={{
                                          "&.Mui-checked": {
                                            color: "#FFCA09",
                                          },
                                        }}
                                      />
                                    </Box>
                                  </td>
                                </MainRowStyle>

                                {/* Submodule Rows */}
                                {expandedRows[`${parentIndex}-${index}`] &&
                                  module?.children?.map(
                                    (
                                      submodule: any,
                                      submoduleIndex: number
                                    ) => (
                                      <SubmoduleRowStyle
                                        key={`${
                                          submoduleIndex + submodule?.value
                                        }`}
                                      >
                                        <td
                                          style={{
                                            paddingLeft: "30px",
                                            textAlign: "left",
                                            fontSize: "0.9rem",
                                          }}
                                        >
                                          {submodule.label}
                                        </td>
                                        <td>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Checkbox
                                              size="small"
                                              checked={
                                                formState?.moduleAccess?.[
                                                  parentIndex
                                                ]?.[index]?.children[
                                                  submoduleIndex
                                                ]?.view
                                              }
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  parentIndex,
                                                  index,
                                                  "view",
                                                  e.target.checked,
                                                  true,
                                                  submoduleIndex
                                                )
                                              }
                                              sx={{
                                                "&.Mui-checked": {
                                                  color: "#FFCA09",
                                                },
                                              }}
                                            />
                                          </Box>
                                        </td>
                                        <td>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Checkbox
                                              size="small"
                                              checked={
                                                formState?.moduleAccess?.[
                                                  parentIndex
                                                ]?.[index]?.children[
                                                  submoduleIndex
                                                ]?.read
                                              }
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  parentIndex,
                                                  index,
                                                  "read",
                                                  e.target.checked,
                                                  true,
                                                  submoduleIndex
                                                )
                                              }
                                              sx={{
                                                "&.Mui-checked": {
                                                  color: "#FFCA09",
                                                },
                                              }}
                                            />
                                          </Box>
                                        </td>
                                        <td>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Checkbox
                                              size="small"
                                              checked={
                                                formState?.moduleAccess?.[
                                                  parentIndex
                                                ]?.[index]?.children[
                                                  submoduleIndex
                                                ]?.write
                                              }
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  parentIndex,
                                                  index,
                                                  "write",
                                                  e.target.checked,
                                                  true,
                                                  submoduleIndex
                                                )
                                              }
                                              sx={{
                                                "&.Mui-checked": {
                                                  color: "#FFCA09",
                                                },
                                              }}
                                            />
                                          </Box>
                                        </td>
                                        <td>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Checkbox
                                              size="small"
                                              checked={
                                                formState?.moduleAccess?.[
                                                  parentIndex
                                                ]?.[index]?.children[
                                                  submoduleIndex
                                                ]?.delete
                                              }
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  parentIndex,
                                                  index,
                                                  "delete",
                                                  e.target.checked,
                                                  true,
                                                  submoduleIndex
                                                )
                                              }
                                              sx={{
                                                "&.Mui-checked": {
                                                  color: "#FFCA09",
                                                },
                                              }}
                                            />
                                          </Box>
                                        </td>
                                      </SubmoduleRowStyle>
                                    )
                                  )}
                              </React.Fragment>
                            ))
                          ) : (
                            <td
                              colSpan={5}
                              style={{
                                backgroundColor: "#FFF",
                                padding: "10px 0px",
                              }}
                            >
                              <Text textAlign={"center"} color="#3C3D37">
                                No data available
                              </Text>
                            </td>
                          )}
                        </tbody>
                      </table>
                    </>
                  )}
                </>
              );
            })}
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default RoleForm;
